import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { ActionItemType } from '../../types/actionSchema';
import { FetchActionsByTypeProductQueryDto } from '../api.dto';

export const fetchActionsByTypeProduct = createAsyncThunk<ActionItemType[], FetchActionsByTypeProductQueryDto>(
  'actions/fetchActionsByTypeProduct',
  async query => {
    let paramsTypeProduct = '';
    if (query?.productType?.length) {
      paramsTypeProduct = query.productType.map(productId => `&productType[]=${productId}`).join('');
    }

    return await MyAxios.get(`/api/actions/v1/get-by-type-product?regionId=${query.regionId}${paramsTypeProduct}`)
      .then(handleResponse)
      .catch(error => handleError(error, []));
  },
);
